import wrap from 'word-wrap';

export default class WordWrap {
    constructor(element) {
        this.element = element;
        this.init();
    }

    init() {
        if (!this.element) return;

        // Read attributes for configuration
        let length = this.element.getAttribute('word-wrap');
        const indent = this.element.getAttribute('word-wrap-indent') || '';
        const newline = this.element.getAttribute('word-wrap-newline') || '<br/>';

        // Default word-wrap length
        length = length ? parseInt(length, 10) : 100;

        // Update the content with wrapped text
        this.element.innerHTML = wrap(this.element.innerHTML.trim(), {
            width: length,
            trim: true,
            escape: (string) => `${indent}${string.trim()}${newline}`,
        });
    }
}